'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491 from "./presto.-Presto-Router$$anon$91.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage$0024 from "./presto.-Register-Directive-Page$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$90() {
  this.bpf = null;
  this.bp7 = null;
  this.bp8 = false;
  this.bpg = null;
  this.bph = false;
  this.bpk = null;
  this.bpd = null;
  this.bpe = false;
  this.bp9 = null;
  this.bpa = false;
  this.bpb = null;
  this.bpc = false;
  this.bpi = false;
  this.bpj = false;
  this.bpf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bpk = "RegisterDirectivePage";
}
export { $c_Lpresto_PrestoRouter$$anon$90 as $c_Lpresto_PrestoRouter$$anon$90 };
$p = $c_Lpresto_PrestoRouter$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$90;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$90() {
}
export { $h_Lpresto_PrestoRouter$$anon$90 as $h_Lpresto_PrestoRouter$$anon$90 };
$h_Lpresto_PrestoRouter$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bpf;
});
$p.L = (function() {
  if ((!this.bp8)) {
    this.bp7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bp8 = true;
  }
  return this.bp7;
});
$p.O = (function() {
  if ((!this.bph)) {
    this.bpg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bph = true;
  }
  return this.bpg;
});
$p.E = (function() {
  return this.bpk;
});
$p.t = (function() {
  if ((!this.bpe)) {
    this.bpd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selector", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpe = true;
  }
  return this.bpd;
});
$p.M = (function() {
  if ((!this.bpa)) {
    this.bp9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpa = true;
  }
  return this.bp9;
});
$p.Q = (function() {
  if ((!this.bpc)) {
    this.bpb = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491.$c_Lpresto_PrestoRouter$$anon$91();
    this.bpc = true;
  }
  return this.bpb;
});
$p.w = (function() {
  if ((!this.bpj)) {
    this.bpi = false;
    this.bpj = true;
  }
  return this.bpi;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee576) => ((p) => \u03b4scrutinee576.cGg(p)))($j_presto$002e$002dRegister$002dDirective$002dPage$0024.$m_Lpresto_RegisterDirectivePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$90, "presto.PrestoRouter$$anon$90", ({
  P0: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$90 as $d_Lpresto_PrestoRouter$$anon$90 };
//# sourceMappingURL=presto.-Presto-Router$$anon$90.js.map
